import React, { useState, useEffect } from "react"
import { Row, Col, Card, CardBody, Input, Button, Table, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap"
import classnames from "classnames"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { ToastContainer, toast } from "react-toastify"
import { Link, useHistory } from "react-router-dom"
import ReactPaginate from "react-paginate"
import { URLS } from "../../Url"
import axios from "axios"

function Products() {
  const GetAuth = localStorage.getItem("authUser")
  const TokenJson = JSON.parse(GetAuth)
  const TokenData = TokenJson.token

  const [Product, setProduct] = useState([])
  const [AdminProduct, setAdminProduct] = useState([])
  const [activeTab, setActiveTab] = useState("1")

  const [myProductsLoaded, setMyProductsLoaded] = useState(false)
  const [adminProductsLoaded, setAdminProductsLoaded] = useState(false)

  const [adminSaleData, setAdminSaleData] = useState({})

  const toggleTab = tab => {
    if (activeTab !== tab) {
      setActiveTab(tab)
    }
  }

  useEffect(() => {
    if (activeTab === "1" && !myProductsLoaded) {
      GetProducts()
    } else if (activeTab === "2" && !adminProductsLoaded) {
      GetAdminProducts()
    }
    Pop_up()
  }, [activeTab, myProductsLoaded, adminProductsLoaded])

  const GetAdminProducts = () => {
    const token = TokenData
    axios
      .post(
        URLS.GetAdminProducts,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then(res => {
        if (res.data.success) {
          setAdminProduct(res.data.products || [])
          setAdminProductsLoaded(true)
        }
      })
      .catch(err => {
        console.error(err)
        toast.error("Failed to load admin products")
      })
  }

  const GetProducts = () => {
    const token = TokenData
    axios
      .post(
        URLS.GetProduct,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then(res => {
        setProduct(res.data.products || [])
        setMyProductsLoaded(true)
      })
      .catch(err => {
        console.error(err)
        toast.error("Failed to load products")
      })
  }

  const [Searchs, setSearchs] = useState({ search: "" })

  const Search = e => {
    const myUser = { ...Searchs }
    myUser[e.target.name] = e.target.value
    setSearchs(myUser)
    const token = TokenData

    axios
      .post(
        URLS.GetProductSearch + `${e.target.value}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then(res => {
        setProduct(res.data.products || [])
        setPageNumber(0)
      })
      .catch(err => {
        console.error(err)
        toast.error("Search failed")
      })
  }

  // Pagination for My Products
  const [listPerPage] = useState(5)
  const [pageNumber, setPageNumber] = useState(0)

  const pagesVisited = pageNumber * listPerPage
  const lists = Product.slice(pagesVisited, pagesVisited + listPerPage)
  const pageCount = Math.ceil(Product.length / listPerPage)
  const changePage = ({ selected }) => setPageNumber(selected)

  // Pagination for Admin Products
  const [adminListPerPage] = useState(5)
  const [adminPageNumber, setAdminPageNumber] = useState(0)

  const adminPagesVisited = adminPageNumber * adminListPerPage
  const adminLists = AdminProduct.slice(adminPagesVisited, adminPagesVisited + adminListPerPage)
  const adminPageCount = Math.ceil(AdminProduct.length / adminListPerPage)
  const adminChangePage = ({ selected }) => setAdminPageNumber(selected)

  // ✅ FIX: These handlers remain the same — the issue was only in the JSX
  const handleAdminCheck = (id) => {
    setAdminSaleData(prev => {
      const isSelected = prev[id]?.selected || false;
      return {
        ...prev,
        [id]: { ...(prev[id] || {}), selected: !isSelected }
      }
    })
  }

  const handleAdminPriceChange = (id, price) => {
    setAdminSaleData(prev => ({
      ...prev,
      [id]: { ...(prev[id] || {}), salePrice: price }
    }))
  }

  const handleAddSelectedAdminProducts = () => {
    const selectedProducts = AdminProduct.filter(
      product => adminSaleData[product._id]?.selected
    )

    if (selectedProducts.length === 0) {
      toast.warning("Please select at least one product")
      return
    }

    const invalidProducts = selectedProducts.filter(
      product => !adminSaleData[product._id]?.salePrice?.trim()
    )

    if (invalidProducts.length > 0) {
      toast.warning("Please enter sale price for all selected products")
      return
    }

    const adminProductIds = selectedProducts.map(product => product._id)
    const salePrices = selectedProducts.map(product => adminSaleData[product._id].salePrice)
    const token = TokenData

    axios
      .post(
        URLS.AddAdminProducts,
        { 
          adminProductId: adminProductIds,
          salePrice: salePrices 
        },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then(res => {
        if (res.data.success) {
          toast.success(res.data.message || `${selectedProducts.length} product(s) added successfully`)
          setAdminSaleData({})
          GetAdminProducts()
        } else {
          toast.error("Failed to add products")
        }
      })
      .catch(err => {
        console.error(err)
        toast.error("Error adding products")
      })
  }

  const history = useHistory()

  const EditProduct = data => {
    sessionStorage.setItem("Productid", data._id)
    history.push("/EditProduct")
  }

  const ViewProduct = data => {
    sessionStorage.setItem("Productid", data._id)
    history.push("/ViewProduct")
  }

  const ManageVarients = data => {
    sessionStorage.setItem("Productid", data._id)
    history.push("/ManageProductVarients")
  }

  const Pop_up = () => {
    const toastMsg = sessionStorage.getItem("tost")
    if (toastMsg) {
      toast.success(toastMsg)
      sessionStorage.removeItem("tost")
    }
  }

  const DeleteData = data => {
    const confirmBox = window.confirm("Do you really want to Delete?")
    if (confirmBox === true) {
      DeleteProductData(data)
    }
  }

  const DeleteProductData = data => {
    const token = TokenData
    const remid = data._id
    axios
      .delete(URLS.DeleteProduct + remid, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(res => {
        if (res.status === 200) {
          toast.success(res.data.message)
          GetProducts()
        }
      })
      .catch(error => {
        if (error.response && error.response.status === 400) {
          toast.error(error.response.data.message)
        } else {
          toast.error("Deletion failed")
        }
      })
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Bizzmate Supplier" breadcrumbItem="Products" />
          <Row>
            <Col>
              <Card>
                <CardBody>
                  <Nav tabs className="nav-tabs-custom nav-justified mb-4">
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({ active: activeTab === "1" })}
                        onClick={() => toggleTab("1")}
                      >
                        <span className="d-block d-sm-none">
                          <i className="fas fa-box"></i>
                        </span>
                        <span className="d-none d-sm-block">My Products</span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({ active: activeTab === "2" })}
                        onClick={() => toggleTab("2")}
                      >
                        <span className="d-block d-sm-none">
                          <i className="fas fa-boxes"></i>
                        </span>
                        <span className="d-none d-sm-block">Admin Products</span>
                      </NavLink>
                    </NavItem>
                  </Nav>

                  <TabContent activeTab={activeTab}>
                    {/* My Products Tab */}
                    <TabPane tabId="1">
                      <Row>
                        <Col>
                          <Link to="/CreateProduct">
                            <Button color="primary" size="sm">
                              New Products <i className="bx bx-plus-circle"></i>
                            </Button>
                          </Link>
                        </Col>
                        <Col>
                          <div style={{ float: "right" }}>
                            <Input
                              type="search"
                              name="search"
                              value={Searchs.search}
                              onChange={Search}
                              className="form-control"
                              placeholder="Search.."
                              autoComplete="off"
                            />
                          </div>
                        </Col>
                      </Row>
                      <div className="table-rep-plugin mt-4 table-responsive">
                        <Table hover bordered responsive>
                          <thead>
                            <tr className="text-center">
                              <th>SlNo</th>
                              <th>Image</th>
                              <th>Name</th>
                              <th>Price</th>
                              <th>Category Name</th>
                              <th>Status</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {lists.map((data, key) => (
                              <tr key={data._id || key} className="text-center">
                                <td>{pagesVisited + key + 1}</td>
                                <td>
                                  <img
                                    src={URLS.Base + data.thumnailImage[0]}
                                    height="50px"
                                    width="50px"
                                    className="img-thumbnail"
                                    alt={data.name}
                                  />
                                </td>
                                <td>{data.name}</td>
                                <td>{data.price}</td>
                                <td>{data.categoryName}</td>
                                <td>
                                  {data.status === "active" ? (
                                    <b className="text-success">{data.status}</b>
                                  ) : (
                                    <b className="text-danger">{data.status}</b>
                                  )}
                                </td>
                                <td>
                                  <i
                                    className="bx bx-edit text-primary me-2"
                                    onClick={() => EditProduct(data)}
                                    style={{ fontSize: "22px", cursor: "pointer" }}
                                  ></i>
                                  <i
                                    className="mdi mdi-eye-circle-outline text-primary me-2"
                                    onClick={() => ViewProduct(data)}
                                    style={{ fontSize: "22px", cursor: "pointer" }}
                                  ></i>
                                  <i
                                    className="bx bx-trash text-primary me-2"
                                    onClick={() => DeleteData(data)}
                                    style={{ fontSize: "22px", cursor: "pointer" }}
                                  ></i>
                                  <i
                                    className="bx bx-cog text-primary"
                                    onClick={() => ManageVarients(data)}
                                    style={{ fontSize: "22px", cursor: "pointer" }}
                                  ></i>
                                </td>
                              </tr>
                            ))}
                            {lists.length === 0 && (
                              <tr>
                                <td colSpan="7" className="text-center">
                                  No Products Found.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </Table>
                        <div className="d-flex mt-3 mb-1" style={{ float: "right" }}>
                          <ReactPaginate
                            previousLabel={"Previous"}
                            nextLabel={"Next"}
                            pageCount={pageCount}
                            onPageChange={changePage}
                            containerClassName={"pagination"}
                            previousLinkClassName={"page-link"}
                            nextLinkClassName={"page-link"}
                            pageClassName={"page-item"}
                            pageLinkClassName={"page-link"}
                            previousClassName={"page-item"}
                            nextClassName={"page-item"}
                            disabledClassName={"disabled"}
                            activeClassName={"active"}
                            breakLabel={"..."}
                            breakClassName={"page-item"}
                            breakLinkClassName={"page-link"}
                          />
                        </div>
                      </div>
                    </TabPane>

                    {/* Admin Products Tab */}
                    <TabPane tabId="2">
                      <div className="table-rep-plugin mt-4 table-responsive">
                        <Table hover bordered responsive>
                          <thead>
                            <tr className="text-center">
                              <th>Select</th>
                              <th>Image</th>
                              <th>Name</th>
                              <th>Price</th>
                              <th>Category</th>
                              <th>Sale Price</th>
                            </tr>
                          </thead>
                          <tbody>
                            {adminLists.map((data, key) => (
                              <tr key={data._id || key} className="text-center">
                                <td onClick={() => handleAdminCheck(data._id)} style={{ cursor: "pointer", verticalAlign: "middle" }}>
                                  <div className="d-flex justify-content-center">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      checked={!!adminSaleData[data._id]?.selected}
                                      onChange={() => {}} // React requires onChange for checked inputs, but we handle it via td click
                                      style={{
                                        width: "1.5rem",
                                        height: "1.5rem",
                                        cursor: "pointer",
                                        marginTop: 0
                                      }}
                                    />
                                  </div>
                                </td>
                                <td>
                                  {data.thumnailImage && data.thumnailImage.length > 0 ? (
                                    <img
                                      src={URLS.Base + data.thumnailImage[0]}
                                      height="50px"
                                      width="50px"
                                      className="img-thumbnail"
                                      alt={data.name}
                                    />
                                  ) : (
                                    "-"
                                  )}
                                </td>
                                <td>{data.name}</td>
                                <td>{data.price}</td>
                                <td>{data.categoryName || "-"}</td>
                                <td>
                                  <Input
                                    type="number"
                                    placeholder="Sale Price"
                                    value={adminSaleData[data._id]?.salePrice || ""}
                                    onChange={(e) => handleAdminPriceChange(data._id, e.target.value)}
                                    style={{ maxWidth: "120px", margin: "auto" }}
                                  />
                                </td>
                              </tr>
                            ))}
                            {adminLists.length === 0 && (
                              <tr>
                                <td colSpan="6" className="text-center">
                                  No Admin Products Found.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </Table>
                        <div className="d-flex justify-content-between align-items-center mt-3">
                          <Button color="primary" onClick={handleAddSelectedAdminProducts}>
                            Add Selected Products
                          </Button>
                          <ReactPaginate
                            previousLabel={"Previous"}
                            nextLabel={"Next"}
                            pageCount={adminPageCount}
                            onPageChange={adminChangePage}
                            containerClassName={"pagination mb-0"}
                            previousLinkClassName={"page-link"}
                            nextLinkClassName={"page-link"}
                            pageClassName={"page-item"}
                            pageLinkClassName={"page-link"}
                            previousClassName={"page-item"}
                            nextClassName={"page-item"}
                            disabledClassName={"disabled"}
                            activeClassName={"active"}
                            breakLabel={"..."}
                            breakClassName={"page-item"}
                            breakLinkClassName={"page-link"}
                          />
                        </div>
                      </div>
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <ToastContainer />
        </div>
      </div>
    </React.Fragment>
  )
}

export default Products